<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.provider_winlose_company") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-12.mb-1
                SubmitButton(
                  icon="fa fa-search"
                  :loading="loading"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getWinLose(true)"
                  variant="primary"
                  size="sm"
                ).mr-2
                jsonToExcel(v-if="winloseList.length > 0" mode="ProviderWinLoseCompany" tbl="tblList" :date="dateRange" btnTxt="export_one" type="0" :loading2="loading").mr-2
                providerWinLoseCompanyExport(v-if="winloseList.length > 0" :tbl="winloseList" :totalTbl="grandTotalList" tblId="tblList")
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12(style="max-height: 70vh; overflow: hidden;")
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.sortable(width="10%" @click="sortOrder('category')")
                          span(:title="$t('ui.category')") {{ $t('ui.category') }}
                          .float-right
                            i(:class="changeSortKey('category')")
                        th.sortable(width="10%")
                          span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                        th(width="15%")
                          span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                        th.text-right.sortable(width="15%" @click="sortOrder('winlose')")
                          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                          .float-right
                            i(:class="changeSortKey('winlose')")
                        th.text-right.sortable(width="15%" @click="sortOrder('turnover')")
                          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                          .float-right
                            i(:class="changeSortKey('turnover')")
                        th.text-right.sortable(width="15%" @click="sortOrder('valid_turnover')")
                          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                          .float-right
                            i(:class="changeSortKey('valid_turnover')")
                    tbody.clusterize-content
                      tr(v-if="winloseList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in winloseList")
                        td
                          span(:title="item.category") {{ item.category }}&nbsp;
                        td
                          span(:title="item.provider_code") {{ item.provider_code }}&nbsp;
                        td
                          span(:title="item.provider_name") {{ item.provider_name }}&nbsp;
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                      tr(v-if="showTotal")
                        td.text-right(colspan="3")
                          span {{ $t("ui.sub_total") }}
                          br
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
// import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import providerWinLoseCompanyExport from "@/components/report/providerWinLoseCompanyExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    providerWinLoseCompanyExport
  },
  data: () => ({
    loading: false,
    grandTotalList: [],
    winloseList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "category",
    sortType: "asc",
    grandTotalList: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
        this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
        this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getWinLose();
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getWinLose(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.currentPage = 1;
      this.getWinLose();
    },
    setReportStatementParam: function() {
      var json = {
        operator_id: this.$store.getters.reportStatement.operator_id,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };
      this.$store.dispatch("user/setReportStatementParam", json);
    },
    getWinLose: function() {
      if (this.checkDateRange()) {
        this.setReportStatementParam();
        let url = config.providerWinLoseCompanyUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.winlose.length > 0) {
                    this.showTotal = true
                    response.data.ds.winlose.forEach(value => {
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                    }

                    this.grandTotalList = response.data.ds.grand_total
                    this.winloseList = response.data.ds.winlose
                    this.totalRow = this.winloseList.length > 0 ? this.winloseList[0].totalrows : 0;
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.winloseList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false;
      this.winloseList = []
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getWinLose();
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getWinLose();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
